import { VOUCHERS_TITLE } from 'enums/vouchers'
import widgetRoutes from 'enums/routes'
import { DEFAULT_FALLBACK_IMAGE } from 'enums/image'
import { TopLevelCard } from 'helpers/determineTopLevelChargeableData'
import { MEMBERSHIPS_TITLE } from 'enums/memberships'
import { RENTALS_TITLE } from 'shared/enums/rentals'
import { ACTIVITIES_TITLE } from 'enums/activities'
import { ACCOMMODATION_TITLE } from 'enums/accommodation'
import { Schedulables } from 'shared/presenters/graphqlTypes'
import { RecursivePartial } from 'shared/presenters/presenter'

export type ChargeableTitle =
  | typeof ACTIVITIES_TITLE
  | typeof VOUCHERS_TITLE
  | typeof RENTALS_TITLE
  | typeof MEMBERSHIPS_TITLE
  | typeof ACCOMMODATION_TITLE

export const DEFAULT_TITLES: ChargeableTitle[] = [
  ACTIVITIES_TITLE,
  VOUCHERS_TITLE,
  RENTALS_TITLE,
  MEMBERSHIPS_TITLE,
  ACCOMMODATION_TITLE
]

type KeyImage =
  | 'activity_key_image'
  | 'voucher_key_image'
  | 'rental_key_image'
  | 'membership_key_image'
  | 'accommodation_key_image'

export const DEFAULT_TITLE_TO_IMAGE_KEY: Record<ChargeableTitle, KeyImage> = {
  [ACTIVITIES_TITLE]: 'activity_key_image',
  [VOUCHERS_TITLE]: 'voucher_key_image',
  [RENTALS_TITLE]: 'rental_key_image',
  [MEMBERSHIPS_TITLE]: 'membership_key_image',
  [ACCOMMODATION_TITLE]: 'accommodation_key_image'
}

export const DEFAULT_IMAGE = DEFAULT_FALLBACK_IMAGE

export const ACTIVITIES_CARD = ({
  widgetSlug,
  cardImage,
  text,
  schedulable
}: {
  widgetSlug: string
  cardImage: string
  text?: string | undefined
  schedulable: RecursivePartial<Schedulables>
}): TopLevelCard => ({
  title: ACTIVITIES_TITLE,
  href: widgetRoutes.ACTIVITIES.url({ widgetSlug }),
  cardImage: cardImage,
  text: text || null,
  schedulable
})

export const VOUCHER_CARD = ({
  widgetSlug,
  cardImage,
  text
}: {
  widgetSlug: string
  cardImage: string
  text?: string | null
}): TopLevelCard => ({
  title: VOUCHERS_TITLE,
  href: widgetRoutes.VOUCHERS.url({ widgetSlug }),
  cardImage: cardImage,
  text: text || null,
  schedulable: {}
})

export const RENTALS_CARD = ({
  widgetSlug,
  cardImage,
  text
}: {
  widgetSlug: string
  cardImage: string
  text?: string | null
}): TopLevelCard => ({
  title: RENTALS_TITLE,
  href: widgetRoutes.RENTALS.url({ widgetSlug }),
  cardImage,
  text: text || null,
  schedulable: {}
})

export const MEMBERSHIPS_CARD = ({
  widgetSlug,
  cardImage,
  text
}: {
  widgetSlug: string
  cardImage: string
  text?: string | null
}): TopLevelCard => ({
  title: MEMBERSHIPS_TITLE,
  href: widgetRoutes.MEMBERSHIPS.url({ widgetSlug }),
  cardImage,
  text: text || null,
  schedulable: {}
})

export const ACCOMMODATION_CARD = ({
  widgetSlug,
  cardImage,
  text
}: {
  widgetSlug: string
  cardImage: string
  text?: string | null
}): TopLevelCard => ({
  title: ACCOMMODATION_TITLE,
  href: widgetRoutes.ACCOMMODATIONS.url({ widgetSlug }),
  cardImage,
  text: text || null,
  schedulable: {}
})
